import React from 'react';
import { splitUsageTypes } from '../utils/requestGroups';

// Compact usage chips for a request card: at most `max` shown, the rest
// folded into a "+N" chip whose tooltip lists them.
export default function UsageChips({ usageTypes, max = 4 }) {
    const all = splitUsageTypes(usageTypes);
    if (!all.length) return null;
    const shown = all.slice(0, max);
    const rest = all.slice(max);
    return (
        <div className="request-group__chips">
            {shown.map((u) => <span key={u} className="request-group__chip" title={u}>{u}</span>)}
            {rest.length > 0 && (
                <span className="request-group__chip request-group__chip--more" title={rest.join(', ')}>+{rest.length}</span>
            )}
        </div>
    );
}
